import AllowDuplicates from './AllowDuplicates'

export default class Clear {
  constructor(
    data,
    options,
    createArea,
    createProject,
    createRepeat,
    createTag,
    createFullTodo,
    deleteAll
  ) {
    this.data = data
    this.options = options
    this.createArea = createArea
    this.createProject = createProject
    this.createRepeat = createRepeat
    this.createTag = createTag
    this.createFullTodo = createFullTodo
    this.deleteAll = deleteAll
  }

  import(incrementProgress, importCompleted) {
    const allowDuplicates = new AllowDuplicates(
      this.data,
      this.options,
      this.createArea,
      this.createProject,
      this.createRepeat,
      this.createTag,
      this.createFullTodo
    )

    this.deleteAll(false, false)
    allowDuplicates.import(incrementProgress, importCompleted)
  }
}
